"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastContent = void 0;
var React = __importStar(require("react"));
var icon_error_svg_1 = __importDefault(require("../../assets/images/icon-error.svg"));
var icon_info_svg_1 = __importDefault(require("../../assets/images/icon-info.svg"));
var icon_warning_svg_1 = __importDefault(require("../../assets/images/icon-warning.svg"));
var loading_black_gif_1 = __importDefault(require("../../assets/images/loading-black.gif"));
var enum_1 = require("../../utils/enum");
var ToastContent = /** @class */ (function (_super) {
    __extends(ToastContent, _super);
    function ToastContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastContent.prototype.render = function () {
        return (React.createElement("div", null,
            this.props.messageTitle ? (React.createElement("div", { className: this.props.type ? 'titleBlock withIcon' : 'titleBlock' },
                this.getIcon(),
                React.createElement("span", { className: 'messageTitle tws-toast-message-title' }, this.props.messageTitle))) : null,
            this.props.message && (React.createElement("div", { className: 'message tws-toast-message' + (this.props.messageTitle ? ' withTitle' : '') }, this.props.message))));
    };
    ToastContent.prototype.getIcon = function () {
        if (this.props.type) {
            if (this.props.type === enum_1.AlertTypes.Warning) {
                return React.createElement("img", { className: 'tws-toast-icon warning-icon' + (' size-' + this.props.iconSize), src: icon_warning_svg_1.default });
            }
            else if (this.props.type === enum_1.AlertTypes.Error) {
                return React.createElement("img", { className: 'tws-toast-icon error-icon' + (' size-' + this.props.iconSize), src: icon_error_svg_1.default });
            }
            else if (this.props.type === enum_1.AlertTypes.Info) {
                return React.createElement("img", { className: 'tws-toast-icon info-icon' + (' size-' + this.props.iconSize), src: icon_info_svg_1.default });
            }
            else if (this.props.type === enum_1.AlertTypes.Processing) {
                return React.createElement("img", { className: 'tws-toast-icon processing-icon' + (' size-' + this.props.iconSize), src: loading_black_gif_1.default });
            }
        }
        return null;
    };
    return ToastContent;
}(React.PureComponent));
exports.ToastContent = ToastContent;
